export const MINIMUM_MEMO_VIEWPORT_WIDTH = 512;

export const REDISTRIBUTION_DEBOUNCE_MS = 100;
